/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SeoButton_linkData = {
    readonly path: string | null;
    readonly isLinkable: boolean | null;
    readonly " $refType": "SeoButton_linkData";
};
export type SeoButton_linkData$data = SeoButton_linkData;
export type SeoButton_linkData$key = {
    readonly " $data"?: SeoButton_linkData$data;
    readonly " $fragmentRefs": FragmentRefs<"SeoButton_linkData">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SeoButton_linkData",
  "type": "LinkData",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isLinkable",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '7d1278475590512cc0a564e9186a15f1';
export default node;
